'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
export default handleActions(_defineProperty({}, ActionTypes.SET_LEGITIMATE_INTEREST_CONFIRMED, function () {
  return true;
}), null);